export interface MovieItem {
  id: number;
  title: string;
  category: string;
  subcategory: string;
  year: number;
  rating: number;
  imageUrl: string;
  description: string;
  genres: string[];
  director: string;
  actors: string[];
  duration: string;
  region: string;
  updateDate: string;
  isHot: boolean;
  isNew: boolean;
  episodes?: string;
}

export interface MovieDetail extends MovieItem {
  fullDescription: string;
  trailerUrl: string;
  relatedIds: number[];
  playCount: string;
  commentCount: number;
  likeCount: number;
}

export const categories = [
  { slug: 'dianying', name: '电影', icon: 'ri-movie-2-line' },
  { slug: 'dianshiju', name: '电视剧', icon: 'ri-tv-2-line' },
  { slug: 'dongman', name: '动漫', icon: 'ri-emotion-line' },
  { slug: 'zongyi', name: '综艺', icon: 'ri-live-line' },
  { slug: 'jilupian', name: '纪录片', icon: 'ri-film-line' },
];

export const movies: MovieItem[] = [
  {
    id: 1,
    title: '流浪地球3',
    category: 'dianying',
    subcategory: '科幻',
    year: 2026,
    rating: 8.5,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20poster%20style%20with%20astronaut%20and%20space%20station%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20warm%20orange%20and%20deep%20black%20tones%2C%20modern%20film%20poster%20design%20with%20Chinese%20text%20space%2C%20clean%20minimal%20background&width=400&height=560&seq=movie-card-01&orientation=portrait',
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。面对未知的宇宙旅程，年轻一代挺身而出，展开一场跨越时空的生死之战。',
    genres: ['科幻', '冒险', '灾难'],
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健'],
    duration: '173分钟',
    region: '中国大陆',
    updateDate: '2026-07-28',
    isHot: true,
    isNew: true,
  },
  {
    id: 2,
    title: '长安三万里2',
    category: 'dianying',
    subcategory: '动画',
    year: 2026,
    rating: 8.8,
    imageUrl: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20animation%20movie%20poster%20Tang%20Dynasty%20poetry%20theme%2C%20traditional%20ink%20painting%20style%2C%20golden%20and%20crimson%20color%20palette%2C%20elegant%20Chinese%20calligraphy%20elements%2C%20soft%20gradient%20background%2C%20artistic%20composition&width=400&height=560&seq=movie-card-02&orientation=portrait',
    description: '安史之乱后，大唐由盛转衰。诗人高适回忆与李白数十年的深厚友情，在历史洪流中追忆那个诗歌璀璨的黄金时代。',
    genres: ['动画', '历史', '剧情'],
    director: '谢君伟',
    actors: ['杨天翔', '凌振赫', '吴俊全'],
    duration: '168分钟',
    region: '中国大陆',
    updateDate: '2026-07-25',
    isHot: true,
    isNew: false,
  },
  {
    id: 3,
    title: '封神第二部',
    category: 'dianying',
    subcategory: '奇幻',
    year: 2026,
    rating: 8.2,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20mythological%20fantasy%20movie%20poster%20with%20ancient%20warriors%20and%20mythical%20beasts%2C%20epic%20battle%20scene%2C%20dramatic%20gold%20and%20crimson%20lighting%2C%20traditional%20Chinese%20aesthetic%2C%20clean%20dark%20background&width=400&height=560&seq=movie-card-03&orientation=portrait',
    description: '殷商大军兵临西岐，姜子牙率领昆仑仙人相助姬发，一场关乎天下苍生的大战即将展开。封神榜的秘密也逐步揭晓。',
    genres: ['奇幻', '动作', '战争'],
    director: '乌尔善',
    actors: ['费翔', '黄渤', '于适'],
    duration: '150分钟',
    region: '中国大陆',
    updateDate: '2026-07-20',
    isHot: true,
    isNew: false,
  },
  {
    id: 4,
    title: '热辣滚烫2',
    category: 'dianying',
    subcategory: '喜剧',
    year: 2026,
    rating: 7.9,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20drama%20movie%20poster%20with%20warm%20kitchen%20scene%2C%20delicious%20food%20and%20cheerful%20atmosphere%2C%20bright%20warm%20lighting%2C%20cute%20illustration%20style%2C%20clean%20cream%20background&width=400&height=560&seq=movie-card-04&orientation=portrait',
    description: '乐莹在拳击之路上继续前行，面对新的挑战和机遇，她用汗水和欢笑书写属于自己的滚烫人生。',
    genres: ['喜剧', '剧情', '运动'],
    director: '贾玲',
    actors: ['贾玲', '雷佳音', '张小斐'],
    duration: '129分钟',
    region: '中国大陆',
    updateDate: '2026-07-18',
    isHot: false,
    isNew: true,
  },
  {
    id: 5,
    title: '深海2',
    category: 'dianying',
    subcategory: '动画',
    year: 2026,
    rating: 8.4,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20fantasy%20film%20poster%20underwater%20deep%20sea%20world%2C%20colorful%20marine%20life%20and%20magical%20creatures%2C%20dreamy%20blue%20and%20gold%20gradient%2C%20particle%20effects%2C%20ethereal%20atmosphere%2C%20clean%20composition&width=400&height=560&seq=movie-card-05&orientation=portrait',
    description: '参宿再次坠入深海世界，这次她需要找到传说中的深海之心，才能拯救濒临崩溃的海底王国。一场更加奇幻瑰丽的深海冒险即将开启。',
    genres: ['动画', '奇幻', '冒险'],
    director: '田晓鹏',
    actors: ['苏鑫', '王亭文'],
    duration: '135分钟',
    region: '中国大陆',
    updateDate: '2026-07-15',
    isHot: false,
    isNew: true,
  },
  {
    id: 6,
    title: '三大队2',
    category: 'dianying',
    subcategory: '犯罪',
    year: 2026,
    rating: 8.1,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20thriller%20movie%20poster%20with%20police%20detective%20in%20dark%20alley%2C%20noir%20lighting%2C%20rainy%20urban%20night%20scene%2C%20mysterious%20atmosphere%2C%20dark%20green%20and%20amber%20tones%2C%20clean%20minimal%20poster%20design&width=400&height=560&seq=movie-card-06&orientation=portrait',
    description: '程兵离开警队后，以普通人的身份继续追踪一起尘封多年的悬案。在追寻真相的路上，他发现了一个更大的阴谋。',
    genres: ['犯罪', '剧情', '悬疑'],
    director: '戴墨',
    actors: ['张译', '李晨', '魏晨'],
    duration: '140分钟',
    region: '中国大陆',
    updateDate: '2026-07-12',
    isHot: false,
    isNew: false,
  },
  {
    id: 7,
    title: '繁花似锦',
    category: 'dianshiju',
    subcategory: '都市',
    year: 2026,
    rating: 8.6,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20urban%20romance%20drama%20poster%20with%20shanghai%20cityscape%20at%20night%2C%20elegant%20couple%20silhouette%2C%20warm%20golden%20city%20lights%2C%20nostalgic%20atmosphere%2C%20soft%20bokeh%20effect%2C%20clean%20composition&width=400&height=560&seq=movie-card-07&orientation=portrait',
    description: '九十年代上海，黄河路上人来人往，阿宝在商海中浮沉，与各路人物展开激烈交锋，书写一段传奇人生。',
    genres: ['都市', '剧情', '爱情'],
    director: '王家卫',
    actors: ['胡歌', '马伊琍', '唐嫣', '辛芷蕾'],
    duration: '40集',
    region: '中国大陆',
    updateDate: '2026-07-30',
    isHot: true,
    isNew: true,
    episodes: '更新至18集',
  },
  {
    id: 8,
    title: '庆余年第三季',
    category: 'dianshiju',
    subcategory: '古装',
    year: 2026,
    rating: 8.9,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20fantasy%20drama%20poster%20with%20ancient%20palace%20and%20sword%20warrior%2C%20majestic%20imperial%20setting%2C%20gold%20and%20crimson%20silk%20drapery%2C%20dramatic%20shadows%2C%20epic%20cinematic%20composition%2C%20clean%20background&width=400&height=560&seq=movie-card-08&orientation=portrait',
    description: '范闲在庆国的权力斗争中越陷越深，他要面对更大的阴谋和挑战。北齐、东夷城各方势力交织，一场席卷天下的风暴即将来临。',
    genres: ['古装', '权谋', '武侠'],
    director: '孙皓',
    actors: ['张若昀', '李沁', '陈道明', '吴刚'],
    duration: '36集',
    region: '中国大陆',
    updateDate: '2026-07-28',
    isHot: true,
    isNew: false,
    episodes: '更新至24集',
  },
  {
    id: 9,
    title: '长相思第二季',
    category: 'dianshiju',
    subcategory: '古装',
    year: 2026,
    rating: 8.3,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20romance%20drama%20poster%20with%20ethereal%20goddess%20in%20flowing%20silk%20dress%2C%20peach%20blossom%20garden%2C%20soft%20dreamy%20lighting%2C%20pink%20and%20gold%20gradient%2C%20ancient%20Chinese%20aesthetic%2C%20clean%20minimal%20background&width=400&height=560&seq=movie-card-09&orientation=portrait',
    description: '小夭在经历重重磨难后，终于面对自己的身世之谜。她与相柳、涂山璟、玱玹之间的情感纠葛走向最终结局。',
    genres: ['古装', '奇幻', '爱情'],
    director: '秦榛',
    actors: ['杨紫', '张晚意', '邓为', '檀健次'],
    duration: '32集',
    region: '中国大陆',
    updateDate: '2026-07-22',
    isHot: false,
    isNew: true,
    episodes: '更新至28集',
  },
  {
    id: 10,
    title: '狂飙2：暗流',
    category: 'dianshiju',
    subcategory: '犯罪',
    year: 2026,
    rating: 8.7,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20police%20crime%20thriller%20drama%20poster%20with%20two%20men%20facing%20each%20other%20in%20dark%20corridor%2C%20split%20lighting%2C%20tension%20atmosphere%2C%20urban%20night%2C%20dark%20turquoise%20and%20warm%20amber%2C%20clean%20composition&width=400&height=560&seq=movie-card-10&orientation=portrait',
    description: '扫黑除恶行动持续深入，安欣与新的犯罪集团展开较量。在新一轮的较量中，隐藏多年的幕后黑手逐渐浮出水面。',
    genres: ['犯罪', '剧情', '悬疑'],
    director: '徐纪周',
    actors: ['张译', '张颂文', '李一桐'],
    duration: '39集',
    region: '中国大陆',
    updateDate: '2026-07-20',
    isHot: true,
    isNew: false,
    episodes: '全39集',
  },
  {
    id: 11,
    title: '斗罗大陆完结篇',
    category: 'dongman',
    subcategory: '热血',
    year: 2026,
    rating: 8.8,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20poster%20with%20martial%20arts%20hero%20in%20dynamic%20battle%20pose%2C%20blue%20energy%20effects%2C%20spirit%20rings%20surrounding%2C%20epic%20fantasy%20landscape%2C%20vibrant%20colors%2C%20action%20composition%2C%20clean%20background&width=400&height=560&seq=movie-card-11&orientation=portrait',
    description: '唐三最终突破封号斗罗境界，在嘉陵关前与武魂殿展开最终决战。海神之力与修罗神力在他体内融合，命运之战一触即发。',
    genres: ['热血', '奇幻', '冒险'],
    director: '沈乐平',
    actors: ['沈磊', '程玉珠', '黄莺'],
    duration: '52集',
    region: '中国大陆',
    updateDate: '2026-07-29',
    isHot: true,
    isNew: true,
    episodes: '更新至248集',
  },
  {
    id: 12,
    title: '完美世界S3',
    category: 'dongman',
    subcategory: '玄幻',
    year: 2026,
    rating: 8.6,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%203D%20anime%20poster%20with%20young%20warrior%20wielding%20magical%20sword%20in%20ancient%20ruins%2C%20celestial%20light%20beams%2C%20floating%20islands%2C%20gold%20and%20jade%20tones%2C%20fantasy%20atmosphere%2C%20clean%20composition&width=400&height=560&seq=movie-card-12&orientation=portrait',
    description: '石昊踏入上界，面对更为强大的对手和更加险恶的考验。他凭借无上毅力突破极限，一步步走向完美世界的最巅峰。',
    genres: ['玄幻', '热血', '冒险'],
    director: '汪成果',
    actors: ['锦鲤', '刘明月', '李兰陵'],
    duration: '78集',
    region: '中国大陆',
    updateDate: '2026-07-26',
    isHot: false,
    isNew: false,
    episodes: '更新至156集',
  },
  {
    id: 13,
    title: '凡人大结局',
    category: 'dongman',
    subcategory: '仙侠',
    year: 2026,
    rating: 9.0,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20xianxia%20anime%20poster%20with%20cultivator%20flying%20on%20sword%20through%20misty%20mountains%2C%20traditional%20ink%20wash%20landscape%2C%20ethereal%20clouds%2C%20moonlight%2C%20serene%20zen%20atmosphere%2C%20elegant%20Chinese%20aesthetic&width=400&height=560&seq=movie-card-13&orientation=portrait',
    description: '韩立历经无数磨难，终于站在了修仙界的巅峰。面对天道规则和飞升之谜，他做出了一个改变三界命运的决定。',
    genres: ['仙侠', '剧情', '冒险'],
    director: '王裕仁',
    actors: ['钱文青', '杨天翔', '乔诗语'],
    duration: '24集',
    region: '中国大陆',
    updateDate: '2026-07-31',
    isHot: true,
    isNew: true,
    episodes: '更新至20集',
  },
  {
    id: 14,
    title: '哈哈哈哈哈第六季',
    category: 'zongyi',
    subcategory: '真人秀',
    year: 2026,
    rating: 7.8,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20with%20group%20of%20celebrities%20laughing%20and%20traveling%2C%20road%20trip%20theme%2C%20bright%20sunny%20scenery%2C%20fun%20and%20energetic%20vibe%2C%20colorful%20casual%20style%2C%20clean%20composition&width=400&height=560&seq=movie-card-14&orientation=portrait',
    description: '五哈团再次出发，这次他们走出国门，在异国他乡展开全新的冒险旅程。欢笑与感动并存，真实记录明星们的旅途故事。',
    genres: ['真人秀', '旅行', '搞笑'],
    director: '李睿',
    actors: ['邓超', '陈赫', '鹿晗', '王勉'],
    duration: '12期',
    region: '中国大陆',
    updateDate: '2026-07-27',
    isHot: false,
    isNew: true,
    episodes: '更新至6期',
  },
  {
    id: 15,
    title: '舌尖上的中国第五季',
    category: 'jilupian',
    subcategory: '美食',
    year: 2026,
    rating: 9.2,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20food%20documentary%20poster%20with%20steaming%20hot%20traditional%20dishes%20on%20wooden%20table%2C%20warm%20kitchen%20atmosphere%2C%20steam%20rising%2C%20rustic%20village%20setting%2C%20rich%20warm%20amber%20lighting%2C%20appetizing%20composition&width=400&height=560&seq=movie-card-15&orientation=portrait',
    description: '新一季跨越山川湖海，探寻中国各地即将消失的传统美食。从东北雪乡到云南雨林，每道菜背后都是人与食物的温暖故事。',
    genres: ['美食', '人文', '旅行'],
    director: '陈晓卿',
    actors: ['李立宏（旁白）'],
    duration: '8集',
    region: '中国大陆',
    updateDate: '2026-07-25',
    isHot: false,
    isNew: false,
    episodes: '全8集',
  },
  {
    id: 16,
    title: '哪吒之魔童闹海2',
    category: 'dianying',
    subcategory: '动画',
    year: 2026,
    rating: 8.9,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20fantasy%20film%20poster%20with%20young%20boy%20warrior%20with%20fire%20wheels%20and%20red%20silk%2C%20mythological%20elements%2C%20dynamic%20action%20pose%2C%20vibrant%20red%20and%20gold%20colors%2C%20traditional%20Chinese%20style%2C%20clean%20dramatic%20background&width=400&height=560&seq=movie-card-16&orientation=portrait',
    description: '哪吒与敖丙在天劫后重塑肉身，但更大的危机正在逼近。龙族复仇、天庭阴谋，两个少年必须再次联手，守护陈塘关。',
    genres: ['动画', '奇幻', '动作'],
    director: '饺子',
    actors: ['吕艳婷', '陈浩', '张珈铭'],
    duration: '148分钟',
    region: '中国大陆',
    updateDate: '2026-08-01',
    isHot: true,
    isNew: true,
  },
];

export const moviesMap: Record<number, MovieItem> = {};
movies.forEach((m) => {
  moviesMap[m.id] = m;
});

export const movieDetails: Record<number, MovieDetail> = {
  1: {
    ...movies[0],
    fullDescription: '在不远的未来，太阳急速衰老膨胀，威胁着整个太阳系的生命。人类提出"流浪地球"计划，在地球表面建造上万座行星发动机，推动地球离开太阳系，前往4.2光年外的比邻星。\n\n《流浪地球3》延续前作的宏大世界观，在地球成功启程后，人类面临着前所未有的挑战。行星发动机频繁故障，地下城内资源日益紧张，人类内部的分歧也愈发严重。\n\n年轻一代挺身而出，他们不仅要面对技术上的难题，还要在人心动荡的末世中寻找希望。影片以惊人的视觉效果展现了地球在宇宙中漂泊的震撼场景，同时深入探讨了人类在绝境中的勇气与团结。\n\n本片汇集了吴京、刘德华、李雪健等实力派演员，郭帆导演以更加成熟的叙事手法，为观众呈现了一部既有视觉震撼又有情感深度的科幻巨制。',
    trailerUrl: '',
    relatedIds: [2, 5, 16],
    playCount: '1.2亿次',
    commentCount: 58642,
    likeCount: 189234,
  },
  7: {
    ...movies[6],
    fullDescription: '九十年代的上海，春风吹拂着黄浦江两岸。黄河路上，霓虹闪烁，人来人往，每个人都有自己的故事。\n\n阿宝，一个从底层打拼起来的年轻人，凭借敏锐的商业嗅觉和过人的胆识，在改革浪潮中崭露头角。他与至真园的老板娘玲子、外贸公司的汪小姐、神秘女子李李之间，交织出一段段爱恨纠缠的故事。\n\n《繁花似锦》不仅仅是一部都市情感剧，更是一幅九十年代上海的众生相。在那个充满机遇与挑战的时代，每个人都在追逐自己的梦想，有人成功了，有人失落了，但上海这座城市始终包容着每一个人。\n\n本剧由王家卫执导，胡歌、马伊琍、唐嫣、辛芷蕾领衔主演，以电影级的画面质感和独特的叙事风格，为观众带来一场视觉与情感的双重盛宴。',
    trailerUrl: '',
    relatedIds: [8, 9, 10],
    playCount: '3.5亿次',
    commentCount: 128900,
    likeCount: 456321,
  },
  11: {
    ...movies[10],
    fullDescription: '斗罗大陆的冒险之旅即将迎来最终章！唐三在经历了海神岛的重重考验后，终于突破封号斗罗境界，获得了海神与修罗神的双重神力。\n\n武魂殿的野心已经暴露无遗，比比东率领武魂帝国大军压境，嘉陵关前战云密布。唐三必须带领天斗帝国联军，与武魂殿展开最终决战。这一战，关乎整个斗罗大陆的命运。\n\n史莱克七怪再次集结，小舞、戴沐白、奥斯卡、马红俊、宁荣荣、朱竹清，每一个人都在战争中成长。友情、爱情、家国情怀，在这场史诗般的决战中交织。\n\n《斗罗大陆完结篇》以更加精良的动画制作和更加紧凑的剧情节奏，为这部陪伴无数观众多年的经典作品画上完美句号。',
    trailerUrl: '',
    relatedIds: [12, 13, 16],
    playCount: '8.2亿次',
    commentCount: 289567,
    likeCount: 892145,
  },
  15: {
    ...movies[14],
    fullDescription: '《舌尖上的中国》第五季，继续以食物为窗口，带领观众领略中国广袤土地上丰富多样的饮食文化。\n\n本季聚焦"即将消失的味道"——那些在现代化浪潮中逐渐被遗忘的传统美食。从东北长白山的野生菌菇采集，到云南西双版纳的傣家竹筒饭；从西北黄土高原的手工挂面，到东南沿海渔村的古法晒盐……\n\n每一种食物背后，都有一个家庭、一个村庄、一段历史。摄制组深入中国最偏远的角落，记录了那些依然坚守传统手艺的人们。他们的故事令人感动，他们的食物令人垂涎。\n\n本季特别关注了气候变化和城镇化对传统饮食文化的影响，以美食为载体，引发人们对文化传承和可持续发展的深思。',
    trailerUrl: '',
    relatedIds: [14, 9, 5],
    playCount: '5600万次',
    commentCount: 32189,
    likeCount: 98765,
  },
};

export const faqData = [
  {
    question: '人人影院的影视资源是否需要付费？',
    answer: '人人影院所有影视资源均免费提供，无需任何付费即可高清在线观看。我们致力于为影迷朋友提供最优质的免费观影体验。',
  },
  {
    question: '人人影院支持哪些设备观看？',
    answer: '人人影院支持全平台观看，包括电脑、平板、手机等设备。只需使用浏览器访问我们的网站，无需下载任何APP，即可随时随地畅享影视盛宴。',
  },
  {
    question: '影视资源多久更新一次？',
    answer: '人人影院的影视资源每日更新，最新上映的电影、热播电视剧、热门综艺等都会在第一时间上线。我们拥有专业的更新团队，确保您不错过任何精彩内容。',
  },
  {
    question: '观看视频为什么会卡顿？如何解决？',
    answer: '视频卡顿通常与网络环境有关。建议您检查网络连接，或尝试切换播放线路。我们的播放器提供多条线路可选，您可以选择最适合您的线路进行观看。',
  },
  {
    question: '人人影院是否有广告？',
    answer: '人人影院致力于提供干净的观影体验，我们尽量减少广告干扰。部分广告是为了维持网站运营的必要成本，感谢您的理解与支持。',
  },
];

export const aboutInfo = {
  brandName: '人人影院',
  founded: '2018年',
  mission: '让每个人都能免费享受高品质影视内容',
  vision: '成为华语地区最受欢迎的免费在线影视平台',
  values: ['用户至上', '内容为王', '技术驱动', '开放共享'],
  stats: [
    { label: '影视资源', value: '10万+' },
    { label: '日活用户', value: '500万+' },
    { label: '累计播放', value: '100亿+' },
    { label: '用户好评', value: '98.6%' },
  ],
  testimonials: [
    {
      name: '张先生',
      role: '资深影迷',
      content: '人人影院是我每天的必刷网站，资源更新快、画质清晰，最重要的是完全免费！推荐给了很多朋友，大家都说好。',
      rating: 5,
    },
    {
      name: '李女士',
      role: '追剧达人',
      content: '自从发现了人人影院，追剧再也不用到处找了。分类清晰、更新及时，还能看到很多冷门好片，真心推荐！',
      rating: 5,
    },
    {
      name: '王同学',
      role: '大学生',
      content: '作为学生党，人人影院简直是福音。不用花钱就能看到最新的电影和动漫，画质也很不错，陪伴了我整个大学生活。',
      rating: 4,
    },
  ],
};